@if (visible()) {
  <div #bannerHost class="locale-setup-banner" role="region" aria-labelledby="localeSetupBannerTitle">
    <div class="locale-setup-banner__start">
      <i class="locale-setup-banner__icon fa-duotone fa-solid fa-globe" aria-hidden="true"></i>

      <p id="localeSetupBannerTitle" class="locale-setup-banner__message">
        <span class="locale-setup-banner__title">PULSE est disponible en français.</span>
        <span class="locale-setup-banner__subtitle" i18n>Available in French.</span>
      </p>
    </div>

    <div class="locale-setup-banner__actions">
      <button type="button" class="locale-setup-banner__cta" (click)="onSwitchToFrench()">Passer au français</button>

      <button type="button" class="locale-setup-banner__close" i18n-aria-label aria-label="Dismiss language banner" (click)="onDismiss()">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  </div>
}
